interface ReportModalProps {
    onClose: () => void;
    children: React.ReactNode;
}

const ReportModal = ({ onClose, children }: ReportModalProps) => {
    return (
      <div className="fixed inset-0 z-[9999] flex flex-col bg-white">
        {/* Sticky header with buttons */}
        <div className="sticky top-0 z-10 bg-white shadow-md p-4 flex justify-between items-center">
          <button
            onClick={onClose}
            className="bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-full p-2 shadow-md flex items-center"
            aria-label="Close"
          >
            <span className="mr-1">Close</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {/* Buffer space for content to appear below the sticky header */}
        <div className="h-8"></div>
  
        {/* Modal Content - Scrollable area */}
        <div className="flex-1 overflow-y-auto overflow-x-auto p-4">
          <div className="flex flex-col items-center justify-center w-full" id="pdf-content">
            <div className="w-full">
              {children}
            </div>
          </div>
        </div>
      </div>
    );
};

export default ReportModal;